//LIGHTBOX
$('.lightbox-toggle').on('click', function() {
  var lightboxId = $(this).attr('data-lightbox');
  var lightboxTitle = $(this).attr('data-lightbox-title');
  var lightboxText = $(this).attr('data-lightbox-text');
  var lightboxBtnText = $(this).attr('data-lightbox-button-text');
  var lightboxLink = $(this).attr('data-lightbox-link');
  $('#' + lightboxId).toggleClass('lightbox-active');
  $('#' + lightboxId + ' .lightbox-content-title').text(lightboxTitle);
  $('#' + lightboxId + ' .lightbox-content-text').append(lightboxText);
  $('#' + lightboxId + ' .lightbox-content-button').text(lightboxBtnText);
  $('#' + lightboxId + ' .lightbox-content-button').attr('href', lightboxLink);

  $('.menu-main-button').removeClass('active');
  $('.header-main, .main-content, .footer-main').removeClass('active');
  $('.btn-fixed-bottom, .btn-call-now, .fixed-item-change').removeClass('menu-active');
  $('body').addClass('body-noscroll');
});
$('.lightbox-container .lightbox-shadow, .lightbox-container .lightbox-close').on('click', function() {
  $('.lightbox-container.lightbox-active').toggleClass('lightbox-active');
  $('.lightbox-container .lightbox-content-title').empty();
  $('.lightbox-container .lightbox-content-text').empty();
  $('.lightbox-container .lightbox-content-button').empty();
  $('body').removeClass('body-noscroll');
});

$(document).ready(function() {
  $(document).on('click', '.btn-toggle-lightbox', function() {
      $lightbox_id = $(this).attr('data-lightbox');
      $('#' + $lightbox_id).toggleClass('lightbox-active');
      $('body').toggleClass('overflow-hidden');
  });

  $(document).on('click', '.lightbox-container.lightbox-active .btn-toggle-lightbox:not(.btn-close)', function() {
      var parent = $(this).parent().closest('.lightbox-container.lightbox-active');
      $(this).parent().closest('.lightbox-container.lightbox-active').removeClass('lightbox-active');
      $('body').removeClass('overflow-hidden');
  });

  $('.lightbox-container .lightbox-content').on('mouseup', function() {
      return false;
  });

  $(document).on('mousedown', function() {

      if ($('.lightbox-container.lightbox-active').length === 2) {
          $(document).on('mouseup', function(e) {
              if ($(e.target).parent('.lightbox-container .lightbox-content').length === 0) {
                  $('.lightbox-container.lightbox-active').removeClass('lightbox-active');
              }
          });

      } else if ($('.lightbox-container.lightbox-active').length === 1) {
          $(document).on('mouseup', function(e) {
              if ($(e.target).parent('.lightbox-container.lightbox-active .lightbox-content').length === 0) {
                  $('.lightbox-container.lightbox-active').removeClass('lightbox-active');
                  $('body.overflow-hidden').removeClass('overflow-hidden');
              }
          });
      } else {}
  });
})